// import '../scss/app.scss';
// import 'swiper/css/bundle';
import {
  burger,
  popup,
  goodsSwiper,
  searchToggle,
  fileInput,
  header,
  formValidator,
  addressModal,
  announcement,
  FilterHandler,
  cookies,
} from './components';
import {
  SENSOR_FITTER_URL,
  SENSOR_SUBFITTER_URL,
  PROBES_FITTER_URL,
  PROBES_SUBFITTER_URL,
  EL_OPER_FITTER_URL,
} from './constans.js';

window.addEventListener('DOMContentLoaded', () => {
  init();

  if (document.querySelector('.leakage-current-sensor')) {
    const sensorFilterHandler = new FilterHandler();
    sensorFilterHandler.init(SENSOR_FITTER_URL, SENSOR_SUBFITTER_URL, true);
  }

  // if (document.querySelector('.current-probes')) {
  //   const probesFilterHandler = new FilterHandler();
  //   probesFilterHandler.init(PROBES_FITTER_URL, PROBES_SUBFITTER_URL, true);
  // }

  if (document.querySelector('.el-oper-tok')) {
    const elOperFilterHandler = new FilterHandler();
    elOperFilterHandler.init(EL_OPER_FITTER_URL, null, false);
  }
});

function init() {
  /* Global */
  burger.init();
  popup.init();
  cookies.init();
  goodsSwiper.init(
    '.goods__cards.swiper',
    {
      width: 355,
      spaceBetween: 20,
      navigation: {
        nextEl: '.button-next',
        prevEl: '.button-prev',
      },
    },
    null
  );
  searchToggle.init();
  fileInput.init(
    '#fileInput',
    '.application-form__label span',
    '.file-icon',
    '.file-button',
    '.application-form__message',
    25 * 1024 * 1024
  );
  header.init();
  formValidator.init();
  addressModal.init();
  announcement.init();
}
